
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const MentorshipListSkeleton: React.FC = () => {
  const skeletonItems = Array(6).fill(0);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {skeletonItems.map((_, index) => (
        <div key={index} className="w-full rounded-xl overflow-hidden border border-[#223342] bg-[#181D24]">
          {/* Cover Image */}
          <Skeleton className="w-full h-48 rounded-none" />
          
          {/* Content */}
          <div className="px-5 pt-5 pb-4 space-y-3">
            {/* Mentor Info */}
            <div className="flex items-center gap-3">
              <Skeleton className="w-10 h-10 rounded-full" />
              <Skeleton className="w-24 h-5" />
            </div>
            
            {/* Title */}
            <Skeleton className="w-4/5 h-6" />
            
            {/* Game */}
            <Skeleton className="w-24 h-4" />
            
            {/* Description */}
            <Skeleton className="w-full h-12" />
            
            {/* Duration */}
            <Skeleton className="w-36 h-4" />
            
            {/* Rating */}
            <Skeleton className="w-20 h-4" />
          </div>
        </div>
      ))}
    </div>
  );
};
